import React, {
    useState, useContext, useEffect, useReducer
} from 'react'

import { Button, TextField, CircularProgress } from '@material-ui/core'

import { Row, Col } from 'react-flexbox-grid'

import * as loginConstants from './constants'
import loginReducer from './reducers'

import { AuthContext } from './context'

import './index.scss'

import PulsarLogo from '../../assets/pulsar-logo.png'

const OperatorLogin = () => {
    const [username, setUsername] = useState('')
    const [password, setPassword] = useState('')

    const authContext = useContext(AuthContext)

    const [loginInfo, dispatch] = useReducer(loginReducer, {
        login: false,
        error: null,
    })

    const { error, token } = loginInfo

    const submitHandler = event => {
        event.preventDefault()

        dispatch({
            type: loginConstants.LOGIN_START,
        })

        fetch('/api/operators/login', {
            method: 'POST',
            body: JSON.stringify({ Username: username, Password: password }),
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then(res => res.json())
            .then(data => {
                const { token: resToken } = data

                if (!data.token) {
                    const { message = 'Unexpected error' } = data

                    throw new Error(message)
                }

                dispatch({
                    type: loginConstants.LOGIN_SUCCESS,
                    payload: { token: resToken, username },
                })
            })
            .catch(err => {
                dispatch({
                    type: loginConstants.LOGIN_FAIL,
                    payload: err.message,
                })
            })
    }

    useEffect(() => {
        if (token) {
            console.log('Got token =>', token)
            authContext.login()
        }
    }, [token, authContext])

    if (authContext.checkUserLoading) {
        return (
            <div className='init-loader-wrapper'>
                <CircularProgress size={60} />
            </div>
        )
    }

    return (
        <div className='OperatorLogin'>
            <Row middle='xs'>
                <Col xs={12}>
                    <Row center='xs' className='logo-row'>
                        <Col xs={12}>
                            <img
                                className='pulsar-logo'
                                src={PulsarLogo}
                                alt='logo'
                            />
                        </Col>
                    </Row>
                    {error && (
                        <Row center='xs'>
                            <Col xs={12} sm={8} md={3}>
                                <div className='Error'>{error}</div>
                            </Col>
                        </Row>
                    )}

                    <form onSubmit={submitHandler}>
                        <Row center='xs'>
                            <Col xs={12} sm={8} md={3}>
                                <TextField
                                    required
                                    fullWidth
                                    type='username'
                                    name='username'
                                    label='Username'
                                    margin='normal'
                                    placeholder='Enter an username'
                                    value={username}
                                    // error={this.state.usernameError}
                                    onChange={event => setUsername(event.target.value)
                                    }
                                    // onKeyPress={e => this.onKeyPress(e)}
                                />
                            </Col>
                        </Row>
                        <Row center='xs'>
                            <Col xs={12} sm={8} md={3}>
                                <TextField
                                    required
                                    fullWidth
                                    type='password'
                                    name='password'
                                    label='Password'
                                    margin='normal'
                                    placeholder='Enter a password'
                                    value={password}
                                    // error={this.state.passwordError}
                                    onChange={event => setPassword(event.target.value)
                                    }
                                    // onKeyPress={e => this.onKeyPress(e)}
                                />
                            </Col>
                        </Row>
                        <Row center='xs' className='submit-row'>
                            <Col xs={12} sm={8} md={3} className='btn-col'>
                                <Button
                                    disabled={
                                        loginInfo.loading
                                        || !username
                                        || !password
                                    }
                                    variant='contained'
                                    type='submit'
                                    color='primary'
                                    className='btn-block'
                                >
                                    Log In
                                </Button>
                            </Col>
                        </Row>
                    </form>
                </Col>
            </Row>
        </div>
    )
}

export default OperatorLogin
